<template>
    <div class="modal fade" role="dialog" id="unbook-modal">
        <div class="modal-dialog">

            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{transEdit('unbook')}}</h5>
                    <button type="button" class="close" data-dismiss="modal">
                        <span><b>x</b></span>
                    </button>
                    <input type="hidden" id="unbook-modal-id">
                </div>
                <div class="modal-body">
                    <h5>{{transEdit('date-and-time')}}: </h5>
                    <h5>
                        <b><span id="unbook-modal-date"></span>, </b>
                        <span id="unbook-modal-time"></span>
                    </h5>

                    <br>
                    <br>

                    <div class="form-check mb-5">
                        <input class="form-check-input" type="checkbox" value="1" v-model="preliminary" id="preliminary">
                        <label class="form-check-label" for="preliminary">Preliminär avbokning</label>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger"
                            v-on:click="unbook()"><i class="fa fa-trash"></i> {{transEdit('unbook')}}</button>
                    <button class="btn btn-dark"
                            data-dismiss="modal"><i class="fa fa-ban"></i> {{transEdit('cancel')}}</button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "admin-schedules-modal-unbook",
        data() {
            return {
                preliminary: 0,
            }
        },

        methods: {
            unbook: function () {
                let self = this;
                let thisModal = $("#unbook-modal");
                let scheduleIdInput = $("#unbook-modal-id");
                let scheduleId = scheduleIdInput.val();

                axios.post(this.$portalUrl('schedules/unbook'), {
                    schedule_id: scheduleId,
                    preliminary: this.preliminary,
                })
                .then(function (response) {
                    self.$emit('refresh');
                })
                .catch(function (error) {
                });

                thisModal.modal('toggle');
            }
        }
    }
</script>

<style scoped>

</style>
